import React, {Component} from 'react';
import {Button, Card, CardBody, Col, Form, Row} from 'reactstrap';
import FormText from './FormText.js';
import FormSelect from './FormSelect.js';
import FormDatePicker from './FormDatePicker.js';

class NewProjectForm extends Component {
	constructor(props) {
		super(props);

		/* Omitted to generate on the API side:
       * project_id
       * property_number
       */

		this.state = {
			error:          '',
			requiredFieldsError: false,
			property_number: '',
			property_name:   '',
			site_address: '',
			time_zone: '',
			reseller: '',
			encl_ordered: '',
			online_expires: ''
		};

		this.handleLocalValueChange = this.handleLocalValueChange.bind(this);
		this.createNewProject = this.createNewProject.bind(this);
		this.triggerFormDateChange = this.triggerFormDateChange.bind(this);
	}

	handleLocalValueChange(event) {
		const target = event.target;
		const usefulArray = target.id.split('-');
		const value = target.value;
		const name = usefulArray[2];
		let nextState = Object.assign({}, this.state);
		nextState[name] = String(value);
		this.setState(nextState);
	}

	triggerFormDateChange(rawID, date) {
		const usefulArray = rawID.split('-');
		const name = usefulArray[2];
		let nextState = Object.assign({}, this.state);
		nextState[name] = String(date);
		this.setState(nextState)
	}

	createNewProject() {
		this.props.setLoading(true);
		let authHeaders = this.props.md5PostXAuthHeaders();
		let postBody = JSON.stringify(this.state);
		const writeURL = `${
			this.props.apiPrefix
		}/bronco/legacy/NewProject/`;
		fetch(writeURL, {
			body:    postBody,
			method:  'POST',
			headers: Object.assign(
				{'content-type': 'application/json'},
				authHeaders
			)
		})
			.catch((error) => {
				this.setState(
					{
						error: `${error} -- Please check your network connection.`
					},
					() => {
						this.props.setLoading(false);
						this.props.changeModalSubsection('ERROR');
					}
				);

				return;
			})
			.then((res) => {
				if (this.state.error) {
					this.props.setLoading(false);
					return;
				}

				if (!res.ok) {
					this.setstate(
						{
							error: `${res.statustext} -- please check your network connection.`
						},
						() => {
							this.props.setloading(false);
							this.props.changemodalsubsection('error');
						}
					);

					return false;
				}

				console.log('!!!');
				console.log(res);
				console.log('!!!');
				return res.json();
			})
			.then((jsonRes) => {
				if (!jsonRes) {
					return;
				}

				let propertyNumber = jsonRes.data.property_number;

				console.log('Successfully created new Project. Message from server:');
				this.setState({ property_number: propertyNumber }, () => {
					this.props.setLoading(false);
					this.props.changeModalSubsection('SUBMITTED');
				});
			});
	}

	render() {
		switch (this.props.createModalSubsection) {
		case 'ERROR':
			return (
				<div>
					<p>An error was encountered: {this.state.error}</p>
				</div>
			);
		case 'SUBMITTED':
			return (
				<Card>
					<CardBody>
						<h2 className="h2">
                Successfully created new project with Property Number:{' '}
							{this.state.property_number}
						</h2>
						<Button
							color="info"
							onClick={() => {
								this.props.handleGetRouteFromSearch(
									this.state.property_number
								);
								this.props.toggleCreateModal();
							}}
						>
                Go to Prop Number #{this.state.property_number} record.
						</Button>
					</CardBody>
				</Card>
			);
		case 'MAIN':
		default: {
			return (
				<div>
					<Col xs={12}>
						<Card className="standard-form border-0">
							<CardBody>
								<Row>
									<form className="new-project-form"
										onSubmit={(e) => {
											e.preventDefault();
											if (this.state.property_name === ''|| 
												this.state.site_address === '' ||
												this.state.time_zone === '' ||
												this.state.encl_ordered === '' ||
												this.state.online_expires === '') {
													this.setState({requiredFieldsError: true})
											} else {
												this.setState({requiredFieldsError: false})
												this.createNewProject();
											}
										}}
									>
										<Col className="new-project" xs={12}>
											<FormText
												colsize={12}
												parentID="new-project"
												label="property_name"
												humanLabel={this.props.makeLabel('property_name')}
												value={this.state.property_name}
												triggerFormValueChange={this.handleLocalValueChange}
											/>
										</Col>
										<Col className="new-project" xs={12}>
											<FormText
												colsize={12}
												parentID="new-project"
												label="site_address"
												humanLabel={this.props.makeLabel('site_address')}
												value={this.state.site_address}
												triggerFormValueChange={this.handleLocalValueChange}
											/>
										</Col>
										<Col className="new-project" xs={12}>
											<FormSelect
												colsize={12}
												parentID="new-project"
												label="time_zone"
												humanLabel={this.props.makeLabel('time_zone')}
												valueArray={this.props.routeData.all_time_zones}
												triggerFormValueChange={this.handleLocalValueChange}
											/>
										</Col>
										<Col className="new-project" xs={12}>
											<FormSelect
												colsize={12}
												parentID="new-project"
												label="reseller"
												humanLabel={this.props.makeLabel('reseller')}
												valueArray={this.props.routeData.all_resellers}
												triggerFormValueChange={this.handleLocalValueChange}
											/>
										</Col>
										<Col className="new-project" xs={12}>
											<FormSelect
												colsize={12}
												parentID="new-project"
												label="encl_ordered"
												humanLabel="Custom Enclosure Hold"
												valueArray={this.props.routeData.all_enclosure_order_opts}
												triggerFormValueChange={this.handleLocalValueChange}
											/>
										</Col>
										<Col className="new-project" xs={12}>
										<FormDatePicker
												colsize={12}
												parentID="new-project"
												label="online_expires"
												humanLabel={this.props.makeLabel('online_expires')}
												date={this.state.online_expires}
												triggerFormDateChange={this.triggerFormDateChange}
											/>
										</Col>
										<Col xs={3} />
										<Col xs={6}>
											<Button color="info" type="submit" className="new-project-submit-btn">
                          						Submit
											</Button>
										</Col>
										<Col xs={12}>
											{this.state.requiredFieldsError === true ? 
												<p className="new-project-required-msg"
												// style={{color: "red", marginLeft: "0.9375rem"}}
												>
													Please enter all required fields</p>
												:
												null
											}
										</Col>
									</form>
								</Row>
							</CardBody>
						</Card>
					</Col>
				</div>
			);
		}
		}
	}
}

export default NewProjectForm;



// WEBPACK FOOTER //
// ./src/components/NewProjectForm.js